module.exports = __webpack_public_path__ + "static/flags/CT-85f6bdd2d8652792fc14d9c663ae9232.gif";